import './index.less';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip, Loading } = checkApp.components;//eslint-disable-line
import Slider from 'react-slick';

let adData = window._sideAd || [
  {
    image: '//img.alicdn.com/tfs/TB1gWm5j2DH8KJjy1XcXXcpdXXa-262-150.jpg',
    link: '//wanwang.aliyun.com/domain/newgtld/#.网店'
  },
  {
    image: '//img.alicdn.com/tfs/TB1pcVVbMoQMeJjy1XaXXcSsFXa-262-150.jpg',
    link: '//wanwang.aliyun.com/domain/newgtld/#.网址'
  },
  {
    image: '//img.alicdn.com/tfs/TB1Ba7pX5qAXuNjy1XdXXaYcVXa-262-150.jpg',
    link: '//wanwang.aliyun.com/domain/newgtld/#.fun'
  },
  {
    image: '//img.alicdn.com/tfs/TB1L._ZhGagSKJjy0FgXXcRqFXa-252-160.jpg',
    link: '//www.aliyun.com/jianzhan'
  }
];

@meta('sideAd', ['request'], -10)
export default class SideADFeature extends Feature {

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderSidePanel')
  renderSidePanel() {

    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dotsClass: 'banner-dots'
    };

    return <div key={this.id} className="panel side side-ad-panel">
      <Slider {...settings}>
        {adData.map((item, index) => {
          return <div key={index}>
            <div className="slider-li">
              <a href={item.link || item.value} target="_blank">
                <img src={item.image || item.text} />
              </a>
            </div>
          </div>;
        })}
      </Slider>
    </div>;
  }

}


// WEBPACK FOOTER //
// ./src/side-ad/index.js